module.exports = __webpack_public_path__ + "img/pt7.bf85e2ae.png";